import actionTypes from '../../action-types'

export default (payload, id) => ({
  type: actionTypes.USER.ARCHIVE,
  payload,
  meta: {
    id,
  },
})
